export default function AnnouncementsTrigger({announcements}) {
    if(announcements.length === 0) return null;

    return <a className="btn text-white btn-sm" data-toggle="collapse" href="#announcementCollapse" role="button" aria-expanded="false" aria-controls="announcementCollapse" style={{marginTop: '0.5rem'}}>
        <i className="fa fa-bullhorn" style={{marginRight: '0.5rem'}}></i>
        <span className="badge badge-light badge-pill">{announcements.length}</span>
        <span className="sr-only">dismissed {announcements.length === 1 ? 'announcement' : 'announcements' }</span>
    </a>
}